import React from 'react'
import Control from 'components/Control/Control'
import AntdInput from 'components/Form/Input'
import DeleteIcon from 'components/icons/DeleteIcon'
import {
  LocalLink,
  LinkWrap,
} from './style'

let duplicateData = []
const getIsDuplicate = (list, type, value) => {
  let isValue
  list?.forEach(([key, values]) => {
    if (key !== type && values?.toLowerCase() === value?.toLowerCase()) {
      if (!duplicateData.includes(values?.toLowerCase() + '_' + type)) {
        duplicateData.push(values?.toLowerCase() + '_' + type)
        isValue = true
        return true
      }
    }
  })
  return isValue
}

export const Hobbies = ({ type, onRemove, hobbieList, getHobbbieList,setIsUpdateButtonEnabled }) => {
  const handleInputChange = (e) => {
    setIsUpdateButtonEnabled(false) 
  };

  return (
    <Control alignCenter gap="15px" bottom="15px">
      <AntdInput
        placeholder="Eg.Skiing"
        name={type}
        maxLength={120}
        rules={[
          {
            min:3,
            max:120,
            message: 'Please enter valid Hobby! Minimum 3 characters',
          },
          {
            validator: async (_, value) => {
              if (value) {
                let isDuplicate = getIsDuplicate(hobbieList, type, value)
                if (isDuplicate) {
                  return Promise.reject(new Error('Hobby already exist'))
                }
              }
              return Promise.resolve()
            },
          },
        ]}
        onChange={handleInputChange}
        onBlur={getHobbbieList}
      />
      <DeleteIcon onClick={onRemove} />
    </Control>
  )
}



export const Languages = ({
  type,
  onRemove,
  languageList,
  getLanguageList,
  setIsUpdateButtonEnabled,
}) => {

  const handleInputChange = (e) => {
    setIsUpdateButtonEnabled(false) 
  };

  return (
    <Control alignCenter gap="15px" bottom="15px">
      <AntdInput
        placeholder="Eg. English"
        name={type}
        maxLength={120}
        rules={[
          {
            min:3,
            max:120,
            message: 'Please enter valid language! Minimum 3 characters',
          },
          {
            validator: async (_, value) => {
              if (value) {
                let isDuplicate = getIsDuplicate(languageList, type, value)
                if (isDuplicate) {
                  return Promise.reject(new Error('Language already exist!'))
                }
              }
              return Promise.resolve()
            },
          },
        ]}
        onChange={handleInputChange}
        onBlur={getLanguageList}
      />
       <div 
          onClick={(e) => {
            e.stopPropagation()
            onRemove?.()
          }}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
          <DeleteIcon />
        </div>
    </Control>
  )
}

export const SocialMedia = ({
  form,
  type,
  onRemove ,
  socialMediaList,
  socialURLList,
  getSocailMediaList,
  copyLink,
  setIsUpdateButtonEnabled
}) => {

const getIsDuplicateLink = (list, type, value) => {
let valid = false
  list?.forEach(([key, values]) => {

    if (key !== type && String(values)?.toLowerCase() === String(value)?.toLowerCase()) {
      valid=true
      
        return true
      
    }
  })
 return valid
}

const handleInputChange = (e) => {
  setIsUpdateButtonEnabled(false) 
};

  return (
    <Control width={'100%'} alignCenter gap="15px" bottom={'15px'} baseLine>
      <AntdInput
        placeholder="Eg.Facebook"
        name={[[type], 'media']}
        maxLength={120}
        rules={[
          {
            required:true,
            min:3,
            max:120,
            message: 'Please enter valid media name! Minimum 3 characters',
          },
          {
            validator: async (_, value) => {
              if (value) {
                let isDuplicate = getIsDuplicate(socialMediaList, type, value)
                if (isDuplicate) {
                  return Promise.reject(new Error('Media name already exist!'))
                }
              }
              return Promise.resolve()
            },
          },
        ]}
        onBlur={getSocailMediaList}
        onChange={handleInputChange}
      />

      <AntdInput
           id={'socilamedialink'}
           placeholder="Eg.facebook.com"
           name={[[type], 'link']}
           type='url'
           rules={[
            {
              required:true,
              message: 'Please enter the media link',
            },
             {
               validator: async (_, value) => {
                 if (value) {
                   let isDuplicate = getIsDuplicateLink(socialURLList, type, value)
                   if (isDuplicate) {
                     return Promise.reject(new Error('Link already exist!'))
                   }
                 }
                 return Promise.resolve()
               },
             },
           ]}
           onBlur={getSocailMediaList}
           onChange={handleInputChange}
        
      />
      <LinkWrap>
        <LocalLink onClick={copyLink} />
      </LinkWrap>
      <LinkWrap>
        <div 
          onClick={(e) => {
            e.stopPropagation()
            onRemove?.()
          }}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
          <DeleteIcon />
        </div>
      </LinkWrap>
    </Control>
  )
}
